import { TileLayer, TileLayerProps } from '@deck.gl/geo-layers/typed';
import { BitmapLayer } from '@deck.gl/layers/typed';
import { useMemo } from 'react';
import { mapConfigStateT } from 'app/hooks/useGetMapSettingsState';
import { getTileSublayerBbox } from 'app/helpers';
import i18n from 'resources/i18n';
import { Tile2DHeader } from '@deck.gl/geo-layers/typed/tileset-2d';
import { BitmapLayerProps } from 'deck.gl/typed';

export const useTileLayer = (mapConfigState: [mapConfigStateT, React.Dispatch<React.SetStateAction<mapConfigStateT>>]) => {
  const mapUrl = useMemo(() => {
    const mapJson = JSON.parse(window._env_[mapConfigState[0].mapname]);

    const langValue = i18n.language ? i18n.language.split('-')[0].toLowerCase() : 'ru';
    let url: string | undefined = '';

    if ('url' in mapJson) {
      url = mapJson.url;
      return url;
    }
    if ('baseurl' in mapJson) {
      url = `https://${mapJson.baseurl}${mapJson.stylename}_${langValue}/{z}/{x}/{y}.${mapJson.tileformat}`;

      return url;
    }
  }, [i18n.language, mapConfigState]);

  const isSatellite = mapConfigState[0].mapname === 'SATELLITE_MAP';

  const renderSubLayersCb = (props: Partial<TileLayerProps> & Partial<BitmapLayerProps> & { tile: Tile2DHeader }) => {
    const bounds = getTileSublayerBbox(props.tile);

    return new BitmapLayer(props, {
      data: undefined,
      image: props.data,
      bounds,
      opacity: 1,
    });
  };

  const tileServerLayer = new TileLayer({
    data: mapUrl,
    id: 'map-tile',

    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,
    renderSubLayers: renderSubLayersCb,
  });

  const tileLayerSatellite = new TileLayer({
    data: mapUrl,
    id: 'map-tile-satellite',

    minZoom: 0,
    maxZoom: 11,
    tileSize: 256,
    renderSubLayers: renderSubLayersCb,
  });
  return isSatellite ? tileLayerSatellite : tileServerLayer;
};
